import { createTheme } from '@mui/material/styles';
import { DesignMode, getDesignTokens } from './designTokens';

export const createDesignTheme = (mode: DesignMode = 'light') => {
  const tokens = getDesignTokens(mode);

  return createTheme({
    palette: {
      mode,
      primary: {
        main: tokens.colors.tealDeep,
        light: tokens.colors.teal,
        contrastText: '#ffffff'
      },
      secondary: {
        main: tokens.colors.gold,
        contrastText: '#0f172a'
      },
      error: {
        main: tokens.colors.red
      },
      success: {
        main: tokens.colors.green
      },
      background: {
        default: tokens.colors.page,
        paper: tokens.colors.surface
      },
      text: {
        primary: tokens.colors.text,
        secondary: tokens.colors.textMuted
      },
      divider: tokens.colors.border
    },
    typography: {
      fontFamily: 'var(--design-font-body)',
      h1: {
        fontFamily: 'var(--design-font-display)',
        fontWeight: 900,
        letterSpacing: 0
      },
      h2: {
        fontFamily: 'var(--design-font-display)',
        fontWeight: 900,
        letterSpacing: 0
      },
      h3: {
        fontFamily: 'var(--design-font-display)',
        fontWeight: 900,
        letterSpacing: 0
      },
      button: {
        fontFamily: 'var(--design-font-body)',
        fontWeight: 900,
        letterSpacing: 0,
        textTransform: 'none'
      },
      allVariants: {
        letterSpacing: 0
      }
    },
    shape: {
      borderRadius: 8
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: tokens.colors.page,
            color: tokens.colors.text
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none'
          }
        }
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true
        },
        styleOverrides: {
          root: {
            textTransform: 'none',
            letterSpacing: 0,
            fontWeight: 900
          }
        }
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            letterSpacing: 0,
            fontWeight: 900
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderColor: tokens.colors.border
          }
        }
      }
    }
  });
};
